import type { RoleEntity } from '@/features/role/domain/entities/RoleEntity'

export class UpdateUserRoleEntity {
  roles?: RoleEntity[]
}
